import { render, staticRenderFns } from "./SetNicNumQueue.vue?vue&type=template&id=53f5851a"
import script from "./SetNicNumQueue.vue?vue&type=script&lang=js"
export * from "./SetNicNumQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports